import DashboardProfile from "./DashboardProfile"
export default DashboardProfile
